<template>
  <div class="page">
    <box fill>
      <el-form
        :model="queryData"
        label-position="right"
        label-width="80px"
        class="EL-Form"
      >
        <el-col :lg="5" :xl="5">
          <el-form-item label="工号" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="queryData.authCode">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="名称" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="queryData.userName">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="库区" class="EL-Form-Item">
            <el-select
              v-model="queryData.waCode"
              multiple
              collapse-tags
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in locationList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getUserAreaAuthList()">
              查询
            </el-button>
            <el-button class="btn-t-delete" @click="resetData()">
              重置
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>

      <el-divider />
      <plabel text="用户库区权限列表">
        <el-button
          v-authority="'BACK_MENU8_M3_B1'"
          class="btn-t-edit"
          @click="onAdd"
        >
          新增
        </el-button>
      </plabel>
      <h-table
        :headerCellStyle="headerCellStyle"
        :style="$popups.harvestRecordStyle(0.8)"
        :data="userAreaAuthTable"
        pagination
        :nowPage.sync="queryData.pageNum"
        :pageSize.sync="queryData.pageSize"
        :total.sync="total"
      >
        <el-table-column
          label="用户角色"
          prop="roleId"
          align="center"
          :formatter="formatterRole"
        />
        <el-table-column label="用户工号" prop="empNumber" align="center" />
        <el-table-column label="库区" prop="waCode" align="center" />
        <el-table-column label="是否启用" prop="isActive" align="center">
          <template slot-scope="scope">
            <div style="color: #67c23a" v-if="scope.row.isActive">是</div>
            <div style="color: #f56c6c" v-else>否</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center" />
        <el-table-column label="修改时间" prop="updateTime" align="center" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-authority="'BACK_MENU8_M3_B2'"
              size="mini"
              type="primary"
              plain
              icon="el-icon-edit-outline"
              @click="onEdit(scope.row)"
            />
            <el-button
              v-authority="'BACK_MENU8_M3_B3'"
              type="danger"
              size="mini"
              plain
              icon="el-icon-delete"
              @click="onDelete(scope.row)"
            />
          </template>
        </el-table-column>
      </h-table>
    </box>

    <!-- 新增||编辑 -->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="dialogVisible"
      width="400px"
      :model="formData"
    >
      <div style="min-height: 20vh;">
        <el-form
          :model="queryData"
          label-position="right"
          label-width="80px"
          class="EL-Form"
        >
          <el-col :lg="24" :xl="24">
            <el-form-item label="用户角色" class="EL-Form-Item is-required">
              <el-select
                v-model="formData.roleId"
                filterable
                placeholder="请选择"
                clearable
                @change="onChangeRole"
              >
                <el-option
                  v-for="(item, index) in roleList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="24" :xl="24">
            <el-form-item label="用户工号" class="EL-Form-Item is-required">
              <el-select
                v-if="formData.userWaId"
                v-model="formData.empNumber"
                filterable
                placeholder="请选择(根据角色获取用户工号)"
              >
                <el-option
                  v-for="(item, index) in userList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                v-else
                v-model="formData.empNumbers"
                multiple
                collapse-tags
                filterable
                placeholder="请选择(根据角色获取用户工号)"
              >
                <el-option
                  v-for="(item, index) in userList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="8">
            <el-form-item label="是否启用" class="EL-Form-Item is-required">
              <el-switch
                v-model="formData.isActive"
                :active-value="true"
                :inactive-value="false"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :disabled="!formData.userWaId"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :lg="24" :xl="24">
            <el-form-item label="库区" class="EL-Form-Item is-required">
              <el-select
                v-model="formData.waCode"
                multiple
                collapse-tags
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in locationList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="dialogVisible = false">
          取 消
        </el-button>
        <el-button
          size="small"
          type="primary"
          :loading="submitLoading"
          v-if="formData.userWaId"
          @click="onSubmit"
        >
          修 改
        </el-button>
        <el-button
          size="small"
          type="primary"
          :loading="submitLoading"
          v-else
          @click="onSubmit"
        >
          新 增
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "user-area-auth",
  data() {
    return {
      queryData: {
        empNumber: "",
        userName: "",
        waCode: [],
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      locationList: [],
      userList: [],
      roleList: [],
      isSetTimeout: null,
      userAreaAuthTable: [],
      dialogVisible: false,
      formData: {
        roleId: "",
        empNumbers: [],
        isActive: true,
        waCode: []
      },
      submitLoading: false
    };
  },
  watch: {
    queryData: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.queryData.pageNum = 1;
          this.getUserAreaAuthList(newVal);
        }, 1000);
      },
      deep: true
    }
  },
  computed: {
    title() {
      return this.formData.userWaId ? "编辑用户库区权限" : "新增用户库区权限";
    }
  },
  mounted() {
    this.getWaCode();
    this.getRoleList();
    this.getUserAreaAuthList();
  },
  methods: {
    // 获取库区
    async getWaCode() {
      try {
        const res = await this.$http.request({
          url: "/api/location/getWaCode",
          method: "GET"
        });
        const { status, data, message } = res;
        if (status === 100) {
          this.locationList =
            data.map(item => {
              return { label: item, value: item };
            }) || [];
        } else {
          this.$message.error(message);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async onChangeRole(id) {
      await this.getUserList(id);
      if (!this.formData.userWaId) {
        this.$set(
          this.formData,
          "empNumbers",
          this.userList.map(i => i.value)
        );
      } else {
        this.formData.empNumbers = [];
        this.formData.empNumber = "";
      }
    },
    // 获取用户
    async getUserList(id) {
      try {
        if (!id) {
          this.userList = [];
          return;
        }
        const res = await this.$http.request({
          url: "/api/userRole/queryUserAccountListByRoleId",
          method: "GET",
          params: {
            roleId: id
          }
        });
        const { status, data, message } = res;
        if (status === 100) {
          this.userList =
            data.map(item => {
              return { ...item, label: item.userName, value: item.empNumber };
            }) || [];
        } else {
          this.$message.error(message);
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 获取角色
    async getRoleList() {
      try {
        const res = await this.$http.request({
          url: "/api/role/getRoleAll",
          method: "GET",
          params: {
            pageNum: 1,
            pageSize: 99999
          }
        });
        const { status, data, message } = res;
        if (status === 100) {
          this.roleList =
            data.list.map(item => {
              return { ...item, label: item.roleName, value: item.roleId };
            }) || [];
        } else {
          this.$message.error(message);
        }
      } catch (e) {
        console.log(e);
      }
    },
    formatterRole(row) {
      const findData = this.roleList.find(item => row.roleId === item.roleId);
      return findData ? findData.roleName : "";
    },
    // 获取用户区域权限
    async getUserAreaAuthList() {
      try {
        const params = { ...this.queryData };
        params.waCode = params.waCode.join(",");
        const res = await this.$http.request({
          url: "/api/userWa/userWaAll",
          method: "GET",
          params: params,
          showLoading: true
        });
        const { status, data, message } = res;
        if (status === 100) {
          this.userAreaAuthTable = data.list || [];
          this.total = data.total;
        } else {
          this.$message.error(message);
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 重置
    resetData() {
      this.queryData = {
        empNumber: "",
        userName: "",
        waCode: [],
        pageNum: 1,
        pageSize: 50
      };
    },
    // 新增
    onAdd() {
      this.formData = {
        roleId: "",
        empNumbers: [],
        isActive: true,
        waCode: []
      };
      this.dialogVisible = true;
    },
    // 编辑
    onEdit(row) {
      this.formData = { ...row };
      this.formData.waCode = row.waCode ? row.waCode.split(",") : [];
      this.$set(this.formData, "empNumbers", [this.formData.empNumber]);
      this.getUserList(this.formData.roleId);
      this.dialogVisible = true;
    },
    onDelete(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            const res = await this.$http.request({
              url: `/api/userWa/deleteById/${row.userWaId}`,
              method: "PUT"
            });
            if (res.status === 100) {
              this.$message.success("删除成功");
              await this.getUserAreaAuthList();
            } else {
              this.$message.error(res.message);
            }
          } catch (e) {
            console.log(e);
          }
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    // 提交
    async onSubmit() {
      try {
        const params = { ...this.formData };
        params.waCode = params.waCode.join(",");
        if (!params.roleId) return this.$message.error("请选择角色");
        if (params.userWaId) {
          if (!params.empNumber) return this.$message.error("请选择用户");
          params.empNumbers = [params.empNumber];
        } else {
          if (!params.empNumbers.length)
            return this.$message.error("请选择用户");
        }
        if (!params.waCode.length) return this.$message.error("请选择库区");
        this.submitLoading = true;
        const res = await this.$http.request({
          url: "/api/userWa/insertOrUpdateUserWa",
          method: "POST",
          data: params
        });
        if (res.status === 100) {
          await this.getUserAreaAuthList();
          const message = this.formData.userWaId ? "修改成功" : "新增成功";
          this.$message.success(message);
          this.dialogVisible = false;
        } else {
          this.$message.error(res.message);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.submitLoading = false;
      }
    },
    headerCellStyle() {
      return "background-color: #1f6cec";
    }
  }
};
</script>

<style scoped lang="scss">
:deep .el-dialog__footer {
  text-align: center;
}
</style>
